<div
  class="jb-max-width center mb6 mb8-ns mt6 mt8-ns"
  *ngIf="bookerData$ | async as bookerData"
>
  <jb-body-text-container
    *ngIf="!flightDeals && serviceError"
    [content]="serviceError"
    [layout]="'center'"
    [theme]="theme"
  ></jb-body-text-container>
  <jb-body-text-container
    *ngIf="flightDeals?.length === 0 && noResults && !isLoading"
    [content]="noResults"
    [layout]="'center'"
    [theme]="theme"
  ></jb-body-text-container>
  <div *ngIf="flightDeals?.length" class="jb-max-width relative cf w-100">
    <div
      class="jb-grid one-up grid-offset-l"
      *ngFor="let deal of flightDeals; let i = index"
      [ngClass]="i + 1 !== flightDeals.length && 'mb2 mb3-ns'"
    >
      <jb-flight-block
        *ngIf="
          !(deal.url | routerLinkFormatter: 'url');
          else linkWrappedFlightBlock
        "
        [link]="deal.url"
        (legalLinkClicked)="openLegalDialog(deal, flightBlock)"
        [attr.data-order]="i + 1"
        [seeRestrictionsCopy]="
          bookerData?.flightBlock?.restrictions || 'See restrictions'
        "
      >
        <jb-image
          *ngIf="flightBlock.showImage == 'true'"
          [alt]="deal.title"
          [src]="deal.image | dynamicImageWidthPipe: 'image'"
          [placeholder]="
            deal.image
              | dynamicImageWidthPipe: 'placeholder' : placeholderParams
          "
          [cropped]="true"
          [isLazy]="enableLazyLoadImage"
          class="destination-image"
        >
        </jb-image>
        <ng-container JbTitle>{{ deal.title }}</ng-container>
        <ng-container JbRoute>{{ deal.from }} to {{ deal.to }}</ng-container>
        <jb-offer-block
          *ngIf="!!flightBlock.offerBlock"
          JbOfferBlock
          [ngClass]="(isMobile | async) ? 'tl' : 'tr'"
        >
          <jb-offer-block-text offerBlockHeader>{{
            flightBlock.offerBlock[0].header
          }}</jb-offer-block-text>
          <jb-offer-block-value
            [valueType]="flightBlock.offerBlock[0].valueType"
            [pointsSuffix]="flightBlock.offerBlock[0].pointsSuffix"
            [currencySymbol]="deal.currencySymbol"
          >
            {{ deal.price | number }}
          </jb-offer-block-value>
          <jb-offer-block-text offerBlockFooter>
            <span
              *ngIf="flightBlock.offerBlock[0].valueType === 'points'"
              class="b"
            >
              +{{ deal.currencySymbol }}{{ deal.taxAmount | number: '1.2' }}
            </span>
            {{ flightBlock.offerBlock[0].footer }}
          </jb-offer-block-text>
        </jb-offer-block>
      </jb-flight-block>

      <ng-template #linkWrappedFlightBlock>
        <a
          [routerLink]="deal.url | routerLinkFormatter: 'url'"
          [queryParams]="deal.url | routerLinkFormatter: 'params'"
          class="no-underline"
        >
          <jb-flight-block
            (legalLinkClicked)="openLegalDialog(deal, flightBlock, $event)"
            [attr.data-order]="i + 1"
            [link]="deal.url"
            [seeRestrictionsCopy]="
              bookerData?.flightBlock?.restrictions || 'See restrictions'
            "
          >
            <jb-image
              *ngIf="flightBlock.showImage == 'true'"
              [alt]="deal.title"
              [src]="deal.image | dynamicImageWidthPipe: 'image'"
              [placeholder]="
                deal.image
                  | dynamicImageWidthPipe: 'placeholder' : placeholderParams
              "
              [cropped]="true"
              [isLazy]="enableLazyLoadImage"
            >
            </jb-image>
            <ng-container JbTitle>{{ deal.title }}</ng-container>
            <ng-container JbRoute>
              {{ deal.from }}
              {{ bookerData?.citySelector?.to?.label | lowercase }}
              {{ deal.to }}
            </ng-container>
            <jb-offer-block
              *ngIf="!!flightBlock.offerBlock"
              JbOfferBlock
              [ngClass]="(isMobile | async) ? 'tl' : 'tr'"
            >
              <jb-offer-block-text offerBlockHeader>
                {{ flightBlock.offerBlock[0].header }}
              </jb-offer-block-text>
              <jb-offer-block-value
                [valueType]="flightBlock.offerBlock[0].valueType"
                [pointsSuffix]="flightBlock.offerBlock[0].pointsSuffix"
                [currencySymbol]="deal.currencySymbol"
              >
                {{ deal.price | number }}
              </jb-offer-block-value>
              <jb-offer-block-text offerBlockFooter>
                <span
                  *ngIf="flightBlock.offerBlock[0].valueType === 'points'"
                  class="b"
                >
                  +{{ deal.currencySymbol }}{{ deal.taxAmount | number: '1.2' }}
                </span>
                {{ flightBlock.offerBlock[0].footer }}
              </jb-offer-block-text>
            </jb-offer-block>
          </jb-flight-block>
        </a>
      </ng-template>
    </div>
  </div>
  <ng-container *ngIf="isLoading">
    <jb-flight-block-skeleton></jb-flight-block-skeleton>
    <jb-flight-block-skeleton></jb-flight-block-skeleton>
    <jb-flight-block-skeleton></jb-flight-block-skeleton>
  </ng-container>
</div>
